import {
  Breakpoints,
  Button,
  ButtonSize,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import { type FC } from 'react';

import { type ArticleWithWrittenAt } from '../../lib/sanity/commonGroqs';
import { DEFAULT_PAGE_SIZE } from '../../utils/pagination';
import { getLibraryPageUrl } from '../../utils/routing';
import { FEATURED_TAG_SLUGS_TO_CMS_TAG } from '../../utils/tags';
import Pagination from '../common/Pagination';

import ArticleCard from './ArticleCard';

interface TagPageProps {
  categorySlug: Possible<string>;
  categoryTitle: Possible<string>;
  tag: string;
  articles: ArticleWithWrittenAt[];
  totalArticles: number;
  page: number;
}

export const TagPage: FC<TagPageProps> = ({
  categoryTitle,
  categorySlug,
  tag,
  articles,
  totalArticles,
  page,
}) => {
  const isSm = useMediaQuery(Breakpoints.SM);

  return (
    <div className="mx-auto mt-10 flex w-11/12 max-w-1500 flex-col pb-8">
      <Link
        href={getLibraryPageUrl({ slug: categorySlug, page: 1 })}
        id="tag_page--back_to_all_articles"
      >
        <Button
          label={`Back to all ${categoryTitle} articles`}
          rounded
          size={ButtonSize.SMALL}
        />
      </Link>
      <h1 className="mt-8 text-4xl font-medium">
        {categoryTitle} articles tagged with{' '}
        <span className="text-leland-gray-extra-light">
          {FEATURED_TAG_SLUGS_TO_CMS_TAG[tag] ?? ''}
        </span>
      </h1>

      <div className="mt-8 grow">
        {articles.length > 0 ? (
          articles.map((article) => (
            <ArticleCard
              key={article._id}
              article={article}
              className="mb-8 transition-opacity lg:hover:opacity-70"
              compact
            />
          ))
        ) : (
          <p>No recent articles.</p>
        )}

        <Pagination
          currentPage={page}
          totalElements={totalArticles}
          pageSize={DEFAULT_PAGE_SIZE}
          buildUrl={(page) => {
            return getLibraryPageUrl({
              slug: categorySlug,
              tag: tag,
              page,
            });
          }}
          maxPageItems={isSm ? 5 : 3}
          useShallowRouting={false}
        />
      </div>
    </div>
  );
};
